import axios from 'axios';
import {API_ROOT} from '../../api-config';

export function getHolidaysWorked(response) {
    axios.defaults.withCredentials = true;
    axios.get(`${API_ROOT}/holidaysworked`, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function (error) {
            if (typeof error.response != "undefined") {
                response(error.response.data);
            } else {
                response({});
            }
        });
}

export function postHolidayWorked(data, response) {
    axios.defaults.withCredentials = true;
    axios.post(`${API_ROOT}/holidaysworked`, data, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function (error) {
            if (typeof error.response != "undefined" && typeof error.response.data != "undefined") {
                response(error.response.data);
            } else {
                response({Message: "Unknown error"});
            }
        });
}

export function deleteHolidayWorked(holiday_worked_id, response) {
    axios.defaults.withCredentials = true;
    axios.delete(`${API_ROOT}/holidaysworked/${holiday_worked_id}`, {withCredentials: true})
        .then(function (ajax_response) {
            response(ajax_response.data);
        })
        .catch(function (error) {
            if (typeof error.response != "undefined" && typeof error.response.data != "undefined") {
                response(error.response.data);
            } else {
                response({Message: "Unknown error"});
            }
        });
}
